import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const wixStyleReactEnvironmentProviderDriverFactory = (
  base: UniDriver,
) => {
  return {
    ...baseUniDriverFactory(base),
  };
};
